var otp;
export default class Vendor_login {
  constructor() {
    this.loginForm = $("#loginForm");
    this.phNoTextField = $("#phNoTextField");
    this.passwordTextField = $("#passwordTextField");
    this.submitBtn = $("#submitBtn");
    this.phnoError = $("#phnoError");
    this.passwordError = $("#passwordError");

    this.forgotPswdMobileNumberInput = $("#forgot-pswd-mobile-number-input");
    this.phoneNotRegisteredError = $("#phone-not-registered");
    this.sendOTPButton = $("#send-otp-button");
    this.OTPInput = $("#otp-input");
    this.saveAndProceedBtn = $("#save-and-proceed");
    this.saveNewPasswordBtn = $("#save-new-password-btn");
    this.saveNewPasswordInput = $("#save-new-password-input");

    this.successNewPassword = $("#success-New-Password");
    this.failureNewPassword = $("#failure-New-Password");
    this.modalTwo = $(".myModalsetpswd");
    //this.OTPError = $("#OTP-error");

    this.loginFailed = $("#loginFailed");
    this.verifyOTPBtn = $("#verify-otp-btn");
    this.OTPSuccess = $("#OTP-success");

    this.forgotPasswordHeader = $("#forgot-pswd-header");
    this.setPasswordHeader = $("#set-pswd-header");
    this.mobileLabel = $("#mobile-label");

    this.OTPLabel = $("#otp-label");
    this.newPasswordLabel = $("#new-password-label");

    // Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    this.submitBtn.on("click", this.doFormAction);
    this.sendOTPButton.on("click", this.doPhoneNumberCheck);
    this.saveNewPasswordBtn.on("click", this.doSaveNewPassword);
    this.verifyOTPBtn.on("click", this.doVerifyOTP);
  };

  doVerifyOTP = () => {
    //e.preventDefault();

    let isOTPValidated = this.verifyOTPFunction();
    if (isOTPValidated) {
      this.OTPSuccess.addClass("text-success");
      this.OTPSuccess.removeClass("text-danger");
      //this.OTPSuccess.html("OTP is verified ");
      //this.OTPInput.prop("disabled", true);
      //this.verifyOTPBtn.addClass("d-none");
      this.saveAndProceedBtn.prop("disabled", false);
      this.forgotPasswordHeader.addClass("d-none");
      this.OTPLabel.addClass("d-none");
      this.OTPInput.addClass("d-none");
      this.verifyOTPBtn.addClass("d-none");
      this.OTPSuccess.addClass("d-none");
      this.setPasswordHeader.removeClass("d-none");
      this.newPasswordLabel.removeClass("d-none");
      this.saveNewPasswordInput.removeClass("d-none");
      this.saveNewPasswordBtn.removeClass("d-none");
    } else {
      this.OTPSuccess.addClass("text-danger");
      this.OTPSuccess.removeClass("text-success");
      this.OTPSuccess.html("Invalid OTP");
    }
  };

  verifyOTPFunction = () => {
    let flag = true;
    let OTPExample = /^\d{4}$/;
    const enteredOtp = String(this.OTPInput.val() || "").trim();
    const sentOtp = String(otp || "").trim();

    if (!enteredOtp.match(OTPExample)) {
      flag = false;
    } else {
      if (sentOtp !== "" && sentOtp === enteredOtp) {
        flag = true;
      } else {
        flag = false;
      }
    }

    return flag;
  };

  doFormAction = (e) => {
    e.preventDefault();

    let isPhValidated = this.Phno_validate();
    if (isPhValidated) {
      this.phnoError.html("");
    }

    let isPasswordValidated = this.Password_validate();
    if (isPasswordValidated) {
      this.passwordError.html("");
    } else {
    }

    if (isPhValidated && isPasswordValidated) {
      this.Submit_Form();
    }
  };

  doPhoneNumberCheck = (e) => {
    e.preventDefault();
    //

    let isForgotPhValidated = this.Forgot_Phno_validate();
    if (isForgotPhValidated) {
      this.phoneNotRegisteredError.html("");
    } else {
      this.phoneNotRegisteredError.html("Please enter valid 10 digit number");
      return;
    }

    let forgotPhoneNumber = this.forgotPswdMobileNumberInput.val();

    $.ajax({
      type: "POST",
      url: baseURL + "api/ForgotPasswordApi/phoneNumber", //phoneNumber is the api
      data: {
        Phone_Number: forgotPhoneNumber, //Phone_Number column name
      },
      headers: { Authorization: X_API_KEY }, //not used

      success: this.checkPhone,
    });
    $.ajax({
      type: "POST",
      url: baseURL + "api/Vendor/SendOTPForgotPassword",

      headers: { Authorization: X_API_KEY },

      data: {
        Phone_Number: forgotPhoneNumber, //Phone_Number column name
      },
      success: (data) => {
        otp = String(data?.OTP || data?.otp || "").trim();
        setTimeout(() => {
          this.OTPSuccess.addClass("text-danger");

          this.OTPSuccess.html("OTP has expired, Try again.");
          otp = null;
        }, 600000);
      },
      error: (err) => {},
    });
  };

  Forgot_Phno_validate = () => {
    let flag = true;
    var forgotphoneno = /^\d{10}$/;
    if (!this.forgotPswdMobileNumberInput.val().match(forgotphoneno)) {
      //this.phoneNotRegisteredError.addClass("d-none");

      flag = false;
    }

    return flag;
  };

  doSaveNewPassword = () => {
    let newPassword = this.saveNewPasswordInput.val();
    let newPassValidation = this.passwordvalidate1();

    if (newPassValidation) {
      let forgotPhoneNumber = this.forgotPswdMobileNumberInput.val();
      $.ajax({
        type: "POST",
        // url: "http://localhost/locaso/api/ForgotPasswordApi/forgotPassword",
        url: baseURL + "api/vendor/UpdatePassword",

        data: {
          Password: newPassword, //Password column name
          Phone_Number: forgotPhoneNumber,
        },

        headers: { Authorization: X_API_KEY },

        success: function (res) {},
      });

      this.successNewPassword.addClass("text-success");
      this.successNewPassword.removeClass("text-danger");

      this.successNewPassword.html(
        "Your password has been successfully updated",
      );
      //this.saveNewPasswordBtn.prop("disabled", true);
      this.saveNewPasswordBtn.addClass("d-none");
      this.saveNewPasswordInput.prop("disabled", true);
      //this.modalTwo.addClass("d-none");
      //this.modalTwo.hide();
      //this.modalTwo.close();

      //let OTPNum = this.OTPInput.val();
    }
  };

  passwordvalidate1 = () => {
    let flag = true;
    // var PasswordExample =
    //   /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
    if (
      !(
        this.saveNewPasswordInput.val().length >= 6 &&
        this.saveNewPasswordInput.val().length <= 15
      )
      // ||
      // !this.saveNewPasswordInput.val().match(PasswordExample)
    ) {
      this.successNewPassword.addClass("text-danger");
      this.successNewPassword.removeClass("text-success");
      this.successNewPassword.html("Please use min 6 and max 15 characters");

      flag = false;
    }
    return flag;
  };

  checkPhone = (res) => {
    let vendorDetails = res.length;

    if (vendorDetails == 0) {
      //alert("This phone number is not registered");
      this.phoneNotRegisteredError.html("This phone number is not registered");
    } else if (vendorDetails == 1) {
      this.phoneNotRegisteredError.addClass("d-none");
      //this.OTPInput.prop("disabled", false);
      this.verifyOTPBtn.prop("disabled", false);

      //this.forgotPswdMobileNumberInput.prop("disabled", true);
      //this.sendOTPButton.prop("disabled", true);

      this.mobileLabel.addClass("d-none");
      this.forgotPswdMobileNumberInput.addClass("d-none");
      this.sendOTPButton.addClass("d-none");

      this.OTPLabel.removeClass("d-none");
      this.OTPInput.removeClass("d-none");
      this.verifyOTPBtn.removeClass("d-none");

      //alert('This phone number is registered');

      // $(document).ready(function(){
      //     sendOTPButton.click(function(){
      //       modalTwo.modal();
      //     });
      //   });
    }
  };

  //validate function
  Phno_validate = () => {
    let flag = true;
    var phoneno = /^\d{10}$/;
    if (!this.phNoTextField.val().match(phoneno)) {
      this.phnoError.html("Please enter only 10 digits for mobile number!");

      flag = false;
    }

    return flag;
  };

  Password_validate = () => {
    let flag = true;

    if (
      !(
        this.passwordTextField.val().length >= 6 &&
        this.passwordTextField.val().length <= 15
      )
    ) {
      this.passwordError.html("Password must be min 6 and max 15 characters");

      flag = false;
    }

    return flag;
  };

  Submit_Form = () => {
    //code for submit form(api and ajax)
    let phoneNumberInput = this.phNoTextField.val();
    let passwordInput = this.passwordTextField.val();
    $.ajax({
      type: "POST",
      url: baseURL + "api/Vendor/login",
      data: this.loginForm.serialize(),
      headers: { Authorization: X_API_KEY },
      success: this.Login_result,
    });
  };
  Login_result = async (res) => {
    if (res.Code == 1) {
      this.loginFailed.html("");
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          url: baseURL + "api/Vendor/setVendorSession",
          data: {
            Phone_Number: this.phNoTextField.val(),
          },
          headers: { Authorization: X_API_KEY },
          success: (res) => {
            var currentVendor_ID = res[0]["Vendor_ID"];
            localStorage.setItem("Vendor_ID", currentVendor_ID);
            window.location = "Vendor_servicing_dashboard";
            // window.location.href = baseURL + "Vendor_servicing_dashboard?userid=" + currentVendor_ID;
            resolve();
          },
          error: resolve,
        });
      });
    } else if (res.Code == 2) {
      this.loginFailed.html("Wrong Password or Phone number!");
    } else if (res.Code == 3) {
      // this.loginFailed.html("Signup Pending");

      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          url: baseURL + "api/Vendor/setVendorSession",
          data: {
            Phone_Number: this.phNoTextField.val(),
          },
          headers: { Authorization: X_API_KEY },
          success: (res) => {
            var currentVendor_ID = res[0]["Vendor_ID"];
            localStorage.setItem("Vendor_ID", currentVendor_ID);
            window.location = "Vendor_details?status=Pending";
            // window.location.href = baseURL + "Vendor_servicing_dashboard?userid=" + currentVendor_ID;
            resolve();
          },
          error: resolve,
        });
      });
    }
  };
}

// success: function(data) {
//   if(data.status == 'success'){
//       alert("Thank you for subscribing!");
//   }else if(data.status == 'error'){
//       alert("Error on query!");
//   }
// },

